import { PayloadAction, createSlice } from '@reduxjs/toolkit'

import { ProjectIdentity, RootStateTypeExtra } from '@store/types'

const projectIdentity = localStorage.getItem('projectIdentity')

const INITIAL_ASSET_OPTIONS: ProjectIdentity['assetOptions'] = {
  localImages: false,
  localVideos: false,
}

let initialState = {
  projectName: '',
  projectId: '',
  projectLabel: '',
  sessionId: [],
  lightMap: '',
  masterKey: '',
  assetPort: '',
  assetOptions: INITIAL_ASSET_OPTIONS,
} as ProjectIdentity

if (projectIdentity) {
  initialState = JSON.parse(projectIdentity)
}

if (!initialState.assetOptions) {
  initialState.assetOptions = INITIAL_ASSET_OPTIONS
}

const projectIdentitySlice = createSlice({
  name: 'projectIdentity',
  initialState,
  reducers: {
    setProjectIdentity: (
      state: ProjectIdentity,
      action: PayloadAction<Partial<ProjectIdentity>>
    ) => {
      localStorage.setItem(
        'projectIdentity',
        JSON.stringify({
          ...state,
          ...action.payload,
        })
      )
      return {
        ...state,
        ...action.payload,
      }
    },
    removeProjectIdentity: (state: ProjectIdentity) => {
      localStorage.removeItem('projectIdentity')
      return {
        ...state,
        ...{
          sessionId: [],
          masterKey: '',
        },
        hideNav: [],
        assetPort: '',
        assetOptions: INITIAL_ASSET_OPTIONS,
      }
    },
  },
})

export const { setProjectIdentity, removeProjectIdentity } =
  projectIdentitySlice.actions

export const selectProject = (state: RootStateTypeExtra) =>
  state.projectIdentity

export default projectIdentitySlice.reducer
